import React, { useState } from 'react';
import { dealerInitiateLogin, dealerVerifyOTP } from '../services/api';

export default function DealerLogin({ onLoginSuccess }) {
  const [step, setStep]               = useState(1);
  const [dealerId, setDealerId]       = useState('');
  const [otp, setOtp]                 = useState('');
  const [sessionId, setSessionId]     = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState('');

  const handleInitiate = async () => {
    if (!dealerId.trim()) return setError('Please enter your Dealer ID.');
    setLoading(true); setError('');
    try {
      const res = await dealerInitiateLogin(dealerId.trim().toUpperCase());
      setSessionId(res.data.sessionId);
      setMaskedEmail(res.data.email);
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed.');
    } finally { setLoading(false); }
  };

  const handleVerify = async () => {
    if (!otp.trim()) return setError('Please enter the OTP.');
    setLoading(true); setError('');
    try {
      const res = await dealerVerifyOTP(sessionId, otp.trim());
      localStorage.setItem('nb_dealer_token', res.data.token);
      localStorage.setItem('nb_dealer', JSON.stringify(res.data.dealer));
      onLoginSuccess(res.data.dealer);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid OTP.');
    } finally { setLoading(false); }
  };

  const Footer = () => (
    <div style={{ marginTop: 32, paddingTop: 16, borderTop: '0.5px solid #e2e8f0' }}>
      <p style={{ color: '#94a3b8', fontSize: 10, textAlign: 'center', marginBottom: 8, fontWeight: 600 }}>
        Navia Markets Ltd · Authorised Dealers Only
      </p>
      <p style={{ color: '#cbd5e1', fontSize: 9, textAlign: 'left', lineHeight: 1.7, margin: 0 }}>
        SEBI Registration No. INZ000095034 – NSE Member code for CM, FAO & CD: 07708 – BSE Clearing No. for CM, FAO & CD: 6341 – MCX Member ID: 45345 – NSDL DP ID: IN300378 – CDSL DP ID: 12086500 – SEBI Registration No. for DP: IN-DP-311-2017 – GST Registration number: 33AAACM4739R2ZZ – Address: 9th Floor, Calavala's Centenary Centre, Door No.9, Club House Road, Chennai – 600 002. Email ID: ig@naviamarkets.com – Contact No. +91-44-39189449
      </p>
      <p style={{ color: '#cbd5e1', fontSize: 9, textAlign: 'left', lineHeight: 1.7, marginTop: 6 }}>
        <strong style={{ color: '#94a3b8' }}>Disclaimer:</strong> Investment in securities market are subject to market risks, read all the related documents carefully before investing. The securities quoted are exemplary and are not recommendatory. Brokerage will not exceed the SEBI prescribed limit.
      </p>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', Arial, sans-serif" }}>
      <div style={{ display: 'flex', width: '100%', maxWidth: 860, borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.12)' }}>

        {/* Left Panel */}
        <div style={{ flex: 1, background: 'linear-gradient(160deg, #1e3a5f 0%, #1d4ed8 100%)', padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 40 }}>
              <div style={{ width: 32, height: 32, background: 'rgba(255,255,255,0.2)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ color: '#fff', fontWeight: 800, fontSize: 14 }}>N</span>
              </div>
              <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Navia Backup</span>
            </div>
            <h2 style={{ color: '#fff', fontSize: 24, fontWeight: 700, margin: '0 0 12px', lineHeight: 1.3 }}>
              Dealer Access<br />Portal
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, lineHeight: 1.7 }}>
              Search client UCC, view positions and holdings, and place square-off on behalf of clients during platform downtime.
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              { label: 'UCC Search',      desc: 'Find any client by UCC' },
              { label: 'SSO Access',      desc: 'View client positions via SSO' },
              { label: 'Sq-Off on Behalf',desc: 'Place orders tracked by Dealer ID' },
            ].map(item => (
              <div key={item.label} style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 14px' }}>
                <div style={{ color: '#fff', fontSize: 12, fontWeight: 600 }}>{item.label}</div>
                <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 11, marginTop: 2 }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Panel */}
        <div style={{ flex: 1, background: '#fff', padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <h3 style={{ color: '#0f172a', fontSize: 20, fontWeight: 700, margin: '0 0 6px' }}>
            {step === 1 ? 'Dealer Sign In' : 'Verify OTP'}
          </h3>
          <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 28px' }}>
            {step === 1 ? 'Enter your Dealer ID to receive OTP' : `OTP sent to ${maskedEmail}`}
          </p>

          <div style={{ display: 'flex', gap: 6, marginBottom: 28 }}>
            {[1, 2].map(s => (
              <div key={s} style={{ flex: 1, height: 3, borderRadius: 2, background: step >= s ? '#1d4ed8' : '#e2e8f0' }} />
            ))}
          </div>

          {error && (
            <div style={{ background: '#fff5f5', border: '1px solid #fed7d7', borderRadius: 8, padding: '10px 14px', marginBottom: 20, color: '#c53030', fontSize: 13 }}>
              {error}
            </div>
          )}

          {step === 1 ? (
            <>
              <label style={{ color: '#374151', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 8 }}>DEALER ID</label>
              <input
                type="text"
                value={dealerId}
                onChange={e => setDealerId(e.target.value.toUpperCase())}
                onKeyDown={e => e.key === 'Enter' && handleInitiate()}
                placeholder="e.g. NB01"
                style={{ width: '100%', padding: '11px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', background: '#f8fafc', color: '#0f172a', fontSize: 15, fontWeight: 600, letterSpacing: 2, outline: 'none', boxSizing: 'border-box', marginBottom: 20 }}
                onFocus={e => e.target.style.borderColor = '#1d4ed8'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
              <button onClick={handleInitiate} disabled={loading} style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: loading ? '#93c5fd' : '#1d4ed8', color: '#fff', fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', boxShadow: '0 4px 12px rgba(29,78,216,0.3)' }}>
                {loading ? 'Sending OTP...' : 'Send OTP →'}
              </button>
            </>
          ) : (
            <>
              <label style={{ color: '#374151', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 8 }}>ONE-TIME PASSWORD</label>
              <input
                type="text"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleVerify()}
                placeholder="000000"
                maxLength={6}
                style={{ width: '100%', padding: '14px', borderRadius: 8, border: '1.5px solid #e2e8f0', background: '#f8fafc', color: '#0f172a', fontSize: 28, fontWeight: 700, letterSpacing: 10, textAlign: 'center', outline: 'none', boxSizing: 'border-box', marginBottom: 8 }}
                onFocus={e => e.target.style.borderColor = '#1d4ed8'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
              <p style={{ color: '#94a3b8', fontSize: 12, marginBottom: 20 }}>Valid for 24 hours</p>
              <button onClick={handleVerify} disabled={loading} style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: loading ? '#86efac' : '#16a34a', color: '#fff', fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 12 }}>
                {loading ? 'Verifying...' : 'Verify & Login →'}
              </button>
              <button onClick={() => { setStep(1); setOtp(''); setError(''); }} style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1.5px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: 13, cursor: 'pointer' }}>
                ← Back
              </button>
            </>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}